/**
 * Sugestão e revisão determinísticas, sem modelo.
 *
 * O protótipo mostra o CosmosAI respondendo nas duas superfícies de conversa —
 * no chat (`zChatMenuOpen`) e no e-mail (`zMailAi`) —, sempre com a etiqueta
 * "Demonstração local". É isso que está aqui: o texto é montado do próprio
 * contexto da conversa, nada sai do navegador e nenhum provedor é chamado.
 *
 * A assistência de verdade é outra coisa e continua valendo o §27.4: ela fala
 * com o endpoint same-origin, só existe no e-mail e nunca entra em produção
 * sem o gate. Por isso a interface nunca chama isto de resposta da IA sem dizer
 * que é demonstração — prometer modelo onde não há é controle falso (§18).
 */

/** Sugestão de resposta a partir de quem é o lead e da última mensagem dele. */
export function localSuggestion(name: string | undefined, lastMessage: string | undefined): string {
  const treatment = name ? name.split(" ")[0] : "Olá";
  if (lastMessage && /\?\s*$/.test(lastMessage.trim()))
    return `${treatment}, ótima pergunta. Consigo te responder com detalhe ainda hoje — prefere por aqui ou numa call rápida?`;
  return `${treatment}, tudo bem? Retomando nossa conversa: consigo te mostrar o próximo passo quando você puder.`;
}

/**
 * Revisão determinística do rascunho.
 *
 * É o "Melhorar meu texto" do protótipo, e faz exatamente o que ele fazia:
 * aperta espaços, cola a pontuação na palavra anterior e abre a frase em
 * maiúscula.
 */
export function improveDraft(draft: string): string {
  const original = draft.trim();
  if (!original) return "";
  let value = original
    .replace(/[^\S\r\n]+/g, " ")
    .replace(/\s+([,.;!?])/g, "$1")
    .replace(/([,;!?])(?=\p{L})/gu, "$1 ");
  value = value.replace(/(^|[.!?]\s+)(\p{Ll})/gu, (_match, lead: string, char: string) =>
    lead + char.toLocaleUpperCase("pt-BR"),
  );
  return /[.!?…]$/.test(value) ? value : `${value}.`;
}
